import { getStatusFromCalendarEvent } from "../../shared/utils/eventStatus";

export const getEventStatus = (event) => getStatusFromCalendarEvent(event);

export const getEventClassName = (event) => {
  let newClassName = "rbc-event";
  const status = getEventStatus(event);
  if (status === "Canceled") newClassName += " canceled";
  else if (status === "Tentative") newClassName += " tentative";
  else if (status === "Scheduled") newClassName += " scheduled";
  else if (status === "Live") newClassName += " live";
  else if (status === "Concluded") newClassName += " concluded";
  return newClassName;
};

